<template lang="pug">
	el-row#menu-header(v-bind:class="{solid: transparent}")
		el-col(:span="4").no-margin
			.logo(v-on:click="scrollMeTo('inicio')")
				span.title PRA

		el-col(:span="7")
			.pesquisa(v-if="this.exibirPesquisa")
				el-button-group
					el-col(:span="6")
						el-select(v-model="value")
							el-option(v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value")
					el-col(:span="15")
						el-input(v-bind:placeholder="frase" @keyup.enter.native="pesquisar()" v-model="codigoPesquisa" v-mask="mascara")#codigoPesquisa
					el-col(:span="3")
						el-button(v-on:click="pesquisar()")
							magnify-icon(:title="''", height="30px", width="30px").icon

		el-col(:span="16")
			el-row
				el-col(:span="3")
					a(v-on:click="scrollMeTo('inicio')") INÍCIO
				el-col(:span="4")
					a(v-on:click="scrollMeTo('sobre')") SOBRE O PRA
				el-col(:span="6")
					a(v-on:click="scrollMeTo('perguntas')") PERGUNTAS FREQUENTES
				el-col(:span="4")
					a(v-on:click="scrollMeTo('downloads')") DOWNLOAD
				el-col(:span="4")
					a(v-on:click="scrollMeTo('contatos')") CONTATOS
				el-col(:span="3")
					el-dropdown(trigger="click")
						span.el-dropdown-link LOGIN
							lock-open-icon.left(:title="''", :width="'14'", :height="'14'")
							i.el-icon-arrow-down.el-icon--right
						el-dropdown-menu(slot="dropdown")
							el-dropdown-item
								a(v-bind:href="url_adequacao" target="_blank") Adequação Ambiental
							el-dropdown-item
								a(v-bind:href="url_centralRt" target="_blank") Central do Responsável Técnico
							el-dropdown-item
								a(v-bind:href="url_entradaUnica" target="_blank") Entrada Única

</template>

<script>

import LockOpenIcon from 'vue-material-design-icons-size/LockOpen.vue'
import RouterMixin from '@/utils/mixins/RouterMixin'
import GeneralService from '../../utils/services/general.service'
import MagnifyIcon from 'vue-material-design-icons-size/Magnify'

export default {
	name: 'MenuHeader',
	mixins: [RouterMixin],
	components: {
		MagnifyIcon,
		LockOpenIcon
	},
	data: function() {

		return {
			exibirPesquisa: false,
			url_entradaUnica: '',
			url_adequacao: '',
			url_sicar: '',
			url_centralRt: '',
			mascara: '###.###.###-##',
			codigoPesquisa: '',
			frase: ['Digite seu CPF aqui'],
			options: [{
				value: 'CPF',
				label: 'CPF'
			}, {
				value: 'CNPJ',
				label: 'CNPJ'
			}, {
				value: 'Cod. Imóvel',
				label: 'Cod. Imóvel'
			}],
			value: 'CPF'
		}

	},
	props: {
		transparent: Boolean
	},
	created: function() {

		var that = this

		GeneralService.getConfig().then(
			function(retorno) {

				var jsonResult = JSON.parse(retorno.request.responseText)
				that.url_adequacao = jsonResult.adequacao
				that.url_sicar = jsonResult.sicar
				that.url_centralRt = jsonResult.centralResponsavelTecnico
				that.url_entradaUnica = jsonResult.entradaUnica

			},
			function() {

			}
		)

	},
	mounted: function() {

		this.$parent.$on('dataPesquisa', this.dataPesquisaSet)

		if(this.$router.currentRoute.path !== '/') {

			this.atualizaPesquisa(this.$route.query.codigoPesquisa)

			this.exibirPesquisa = true

		}

	},
	methods: {

		atualizaPesquisa(newVal) {

			var that = this

			if(newVal === undefined) {

				that.newVal = 'CPF'

			}

			if(newVal.length <= 14) {

				that.value = 'CPF'

			}

			if(newVal.length <= 20 && newVal.length > 14) {

				that.value = 'CNPJ'

			}

			if(newVal.length > 20) {

				that.value = 'Cod. Imóvel'

			}

			setTimeout(function() {

				that.codigoPesquisa = newVal

			}, 0)

		},
		dataPesquisaSet(data) {

			this.codigoPesquisa = data.codigoPesquisa
			this.value = data.value

		},
		pesquisar() {

			this.$router.push({ name: 'Resultados', query: { codigoPesquisa: this.codigoPesquisa } })

		},
		scrollMeTo(refName) {

			if(this.$router.currentRoute.path !== '/') {

				this.$router.push('/')

			}

			this.$nextTick(function() {

				this.$parent.$emit('moveToDiv', refName)

			})

		},
		apagaDados() {

			this.codigoPesquisa = ''

		}
	},
	watch: {
		codigoPesquisa: function(newVal) {

			this.codigoPesquisa = newVal.toUpperCase()

		},
		'$route.path': function(newVal) {

			if(newVal !== '/') {

				this.exibirPesquisa = true

			} else {

				this.exibirPesquisa = false

			}

		},
		'$route.query.codigoPesquisa': function(newVal) {

			if(newVal) {

				this.atualizaPesquisa(newVal)

			}

		},
		value: function(newVal) {

			var that = this

			this.apagaDados()

			setTimeout(function() {

				if(newVal === 'CPF') {

					that.frase = 'Digite seu CPF aqui'
					that.mascara = '###.###.###-##'

				} else if(newVal === 'CNPJ') {

					that.frase = 'Digite o CNPJ aqui'
					that.mascara = '##.###.###/####-##'

				} else if(newVal === 'Cod. Imóvel') {

					that.frase = 'Digite o código do imóvel aqui'
					that.mascara = 'AA-#######-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX'

				}

			}, 1)

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/MenuHeader.vue